package com.fireavert.fire_risk.client

import com.fireavert.cache.client.Preferences
import com.fireavert.common.ApiRepository
import com.fireavert.common.Try
import com.fireavert.fire_risk.data_models.TenantFireRiskDataModel
import com.fireavert.logging.Logger
import com.fireavert.user.data_models.TokenRefreshService
import kotlinx.coroutines.CoroutineDispatcher
import kotlinx.coroutines.withContext

class ClientTenantFireRiskRepositoryImpl(
    private val dataSource: TenantFireRiskDataSource,
    private val keyValuePreferences: Preferences,
    ioContext: CoroutineDispatcher,
    tokenRefreshService: TokenRefreshService,
    private val logger: Logger
) : ClientTenantFireRiskRepository, ApiRepository(ioContext, tokenRefreshService) {

    override suspend fun getTenantFireRiskAllProperties(propertyId: Int?): Try<List<TenantFireRiskDataModel>> {
        return withContext(ioContext) {
            callWithRefresh { dataSource.getTenantFireRiskByPropertyList(propertyId, keyValuePreferences.token) }
                .map { tenantFireRiskResponse ->
                    tenantFireRiskResponse.tenantFireRiskList
                }
        }
    }
}